import { Component, Injector, Input, OnInit } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { BaseComponent } from 'sigv-library';

@Component({
  selector: 'app-date-field-error',
  templateUrl: './date-field-error.component.html',
  styleUrls: ['./date-field-error.component.scss'],
})
export class DateFieldErrorComponent extends BaseComponent implements OnInit {
  @Input() control!: AbstractControl;
  @Input() hidden = false;
  @Input() showRequired = false;
  @Input() fieldName!: string;

  errorsMap!: Map<string, string>;
  constructor(private injector: Injector) {
    super(injector);
    this.errorsMap = new Map();
    this.errorsMap.set('required', 'Common.Validate.MustNotBeBlank');
    this.errorsMap.set('invalidDate', 'Common.Validate.InvalidDate');
    this.errorsMap.set('overMaxDate', 'Common.Validate.OverMaxDate');
    this.errorsMap.set('overMinDate', 'Common.Validate.OverMinDate');
  }

  ngOnInit(): void {}
}
